export default "__VITE_ASSET__xtzEwj_1__"